import { useWizard } from "react-use-wizard";
import buySteps from "../buySteps";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../..";
import FacilityTypeStep from "../../../../../../shared/wizard/steps/facilityTypeStep";

interface ISelectionBuyOwnAppStep_2 {
  isNextStepDisabled: boolean;
  onChange: (data: number, key: TNumberKeysOfIFillDataWizardBuy) => void;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
  data: number | null;
}

const SelectionBuyOwnAppStep_2 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: ISelectionBuyOwnAppStep_2) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.step_1);
    onReset(["selectedFacilityTypeOwnFacility"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.step_3);
  };

  const handleChange = (selectedId: number) => {
    onChange(selectedId, "selectedFacilityTypeOwnFacility");
  };

  return (
    <div>
      <FacilityTypeStep
        isNextStepDisabled={isNextStepDisabled}
        onChange={handleChange}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        data={data ? [data] : []}
        mode="default"
        text={"Укажите свою планировку:"}
      />
    </div>
  );
};

export default SelectionBuyOwnAppStep_2;
